import type { Component } from '@inter-ikea-core/core'

import { SOFA_CORE_ID } from '../constants/component-ids'

export class MeasurementVisibleComponent implements Component {
  doStoreInSnapshot = false
  isVisible: boolean
  serializable = false
  typeId = SOFA_CORE_ID.MEASUREMENT_VISIBLE_COMPONENT

  constructor(isVisible: boolean) {
    this.isVisible = isVisible
  }

  eq(other: MeasurementVisibleComponent): boolean {
    return this.isVisible === other.isVisible
  }
}
